import { Component, OnInit, Input } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Utilerias } from 'src/app/helpers/Utilerias';
declare var $: any;

@Component({
  selector: 'app-evidencias',
  templateUrl: './evidencias.component.html',
  styleUrls: ['./evidencias.component.css']
})
export class EvidenciasComponent implements OnInit {
  @Input() evidencias;
  loadEvidencia = false;

  constructor(private http: HttpClient) { }

  ngOnInit() {
  }

  loadVideo(idEvidencia) {
    this.loadEvidencia = true;
    this.getContentEvidencia(idEvidencia)
      .then((res: any) => {
        $('#video').attr('src', 'data:video/' + this.getFileExtension(res.NombreEvidencia + ';base64,' + res.ContenidoEvidenciaBase64));
        $('#modalEvidenciaVideo').modal('show');
        this.loadEvidencia = false;
      })
  }

  getContentEvidencia(idEvidencia) {
    return Utilerias.httpRequest(this.http, 'GetTranEvidencia', 'post', { idEvidencia: idEvidencia });
  }

  evidenciaClick(evidencia) {
    this.getContentEvidencia(evidencia.IdEvidencia)
      .then((res: any) => {
        $('#imgEvidencia').attr('src', 'data:image/' + this.getFileExtension(res.NombreEvidencia + ';base64,' + res.ContenidoEvidenciaBase64));
        $('#modalEvidencia').modal('show');
      })
  }

  getFileExtension(filename) {
    return filename.slice((filename.lastIndexOf(".") - 1 >>> 0) + 2);
  }

  getPDF(evidencia) {
    this.loadEvidencia = true;
    this.getContentEvidencia(evidencia.IdEvidencia)
      .then((res: any) => {
        Utilerias.downloadFile(res.NombreEvidencia, res.ContenidoEvidenciaBase64);
        this.loadEvidencia = false;
      })
  }
}
